import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M38.756 13.043H1.244A19.957 19.957 0 0 0 0 20c0 2.446.44 4.79 1.244 6.956h37.512A19.957 19.957 0 0 0 40 20c0-2.446-.44-4.79-1.244-6.957Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 0C13.938 0 8.506 2.697 4.839 6.957H35.16C31.493 2.697 26.06 0 20 0Zm15.16 33.044H4.84A19.95 19.95 0 0 0 20 40c6.062 0 11.493-2.697 15.16-6.956Z"
}, null, -1), i = [
  l,
  n,
  s
];
function d(r, _) {
  return e(), o("svg", c, [...i]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
